<template>
    <div>
        <label class="block text-sm font-semibold text-glm-black mb-1" :for="internalId">
            <slot name="label"></slot>
        </label>

        <input
            v-if="isSimpleInput(type)"
            :type="type"
            :value="value"
            @input="$emit('input', $event.target.value)"
            :id="internalId"
            :placeholder="placeholder"
            :disabled="disabled"
            class="w-full px-3 py-2 mb-1 border border-grey-300 rounded focus:border-glm-blue transition-colors shadow-sm focus:ring focus:ring-glm-blue focus:ring-opacity-20 focus:ring-offset-2"
        >

        <select
            v-if="type === 'select'"
            :id="internalId"
            @change="$emit('input', $event.target.value)"
            class="w-full px-3 py-2 mb-1 border border-grey-300 rounded focus:outline-none focus:border-glm-blue transition-colors shadow-sm focus:ring focus:ring-glm-blue focus:ring-opacity-20 focus:ring-offset-2 disabled:opacity-50"
            :disabled="disabled"
        >
            <option v-for="option in options" :value="option.value" :selected="value === option.value">
                {{ option.label }}
            </option>

            <option v-if="textIfNoOption && options.length === 0">
                {{ textIfNoOption }}
            </option>
        </select>

        <select
            v-if="type === 'group'"
            :id="internalId"
            @change="$emit('input', $event.target.value)"
            class="w-full px-3 py-2 mb-1 border border-grey-300 rounded focus:outline-none focus:border-glm-blue transition-colors shadow-sm focus:ring focus:ring-glm-blue focus:ring-opacity-20 focus:ring-offset-2 disabled:opacity-50"
            :disabled="disabled"
        >
            <optgroup :label="group.label" v-for="group in options">
                <option v-for="option in group.options" :value="option.value" :selected="value === option.value">
                    {{ option.label }}
                </option>
            </optgroup>

            <option v-if="textIfNoOption && options.length === 0">
                {{ textIfNoOption }}
            </option>
        </select>

        <div v-show="error">
            <p class="text-sm text-red-600">
                {{ error }}
            </p>
        </div>

        <div v-show="description">
            <p class="text-sm text-grey-500">
                {{ description }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            required: true,

            type: String,

            validator: function (value) {
                return ['text', 'number', 'select', 'group'].indexOf(value) !== -1
            },
        },

        value: String,

        error: String,

        description: String,

        disabled: Boolean,

        id: {
            required: true,

            type: String,
        },

        placeholder: {
            type: String,

            default: '',
        },

        options: {
            type: Array,

            default: () => [],
        },

        textIfNoOption: String,
    },

    data () {
        return {
            rand: Math.random() * 100,

            simpleInputTypes: [
                'text',
                'number',
            ],
        }
    },

    methods: {
        isSimpleInput (type) {
            return this.simpleInputTypes.indexOf(type) !== -1
        },
    },

    computed: {
        internalId () {
            return this.id + '-' + this.rand
        },
    },
}
</script>
